import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WishlistMessageComponent } from '../../../wishlist/message/wishlist-message.component';
import { ProductEventData } from '../../product.abstract';
import { ProductViewWishlistAbstract } from '../../view/wishlist/product-view-wishlist.abstract';
import { ProductListingWishlistConfigurableOptionsComponent } from './configurable-options/product-listing-wishlist-configurable-options.component';

@Component({
    selector: 'product-listing-wishlist',
    templateUrl: './product-listing-wishlist.component.html',
    styleUrl: './product-listing-wishlist.component.scss',
    standalone: true,
    imports: [NgClass, ProductListingWishlistConfigurableOptionsComponent, WishlistMessageComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingWishlistComponent extends ProductViewWishlistAbstract {
    protected override onPrepareEvent(data: ProductEventData) {
        // do nothing
    }
}
